import { useContext, useEffect, useState } from 'react'
import last from 'lodash/last'

import MediaContext from './mediaContext'

import getResponsiveHelper from './getResponsiveHelper'

export default () => {
  const q = useContext(MediaContext)
  const [clientRender, setClientRender] = useState()
  useEffect(() => {
    setClientRender(true)
  }, [])
  return {
    ...getResponsiveHelper(q, clientRender),
    getCurrentValue: (resArr) => {
      const ff = q.findIndex(v => !v)
      return ff === -1 ? last(resArr) : resArr[ff]
    },
  }
}
